import {
  TRIP_DETAILS_PATH_LEGACY,
  tripDetailsParamNamesLegacy,
  TRIP_DETAILS_PATH,
  tripDetailsParamNames,
} from "./consts.js";
import { toUrlParams } from "@holisto-web/shared/url-params";
import { generatePath } from "react-router";

/** Kept for the redirect integration test that verifies backward compatibility for old bookmarked trip links. */
export const getTripDetailsPathLegacy = (
  hotelId: string,
  tripId: string | number,
  params?: { email: string },
): string => {
  const path = generatePath(TRIP_DETAILS_PATH_LEGACY, {
    [tripDetailsParamNamesLegacy.tripId]: String(tripId),
    [tripDetailsParamNamesLegacy.hotelId]: hotelId,
  });

  if (params) {
    const urlParams = toUrlParams(params);
    return `${path}?${urlParams}`;
  }

  return path;
};

export const getTripDetailsPath = (hotelId: string | number, tripKey: string): string => {
  return generatePath(TRIP_DETAILS_PATH, {
    [tripDetailsParamNames.tripKey]: tripKey,
    [tripDetailsParamNames.hotelId]: String(hotelId),
  });
};
